export default __webpack_public_path__ + "static/media/elevate-blk-poster-3.35e1ca14.jpg";